import * as React from 'react';
import styles from './index.less';
import cx from 'classnames';
import { isArray } from '@src/utils/type-utils';
import lockAsync from '@src/utils/lock-async';
import protect from '@src/error/protect';
// import { message } from 'antd';
import AntdMessage from '@src/components/antd/message';

export default class NineSquarePrize extends React.Component {
  static defaultProps = {
    /**
     * 奖品列表
     * 请严格按照数据格式传入，因为第五个格子为开始按钮，所以能渲染的数据量上限为8个
     */
    prizeList: [
      { name: '奖品名称', id: 1, index: 1 /*(九宫格中的索引位置，最大为8)*/ },
      { name: '奖品名称', id: 2, index: 2 /*(九宫格中的索引位置，最大为8)*/ },
      { name: '奖品名称', id: 3, index: 3 /*(九宫格中的索引位置，最大为8)*/ },
      { name: '奖品名称', id: 4, index: 4 /*(九宫格中的索引位置，最大为8)*/ },
      { name: '奖品名称', id: 5, index: 5 /*(九宫格中的索引位置，最大为8)*/ },
      { name: '奖品名称', id: 6, index: 6 /*(九宫格中的索引位置，最大为8)*/ },
      { name: '奖品名称', id: 7, index: 7 /*(九宫格中的索引位置，最大为8)*/ },
      { name: '奖品名称', id: 8, index: 8 /*(九宫格中的索引位置，最大为8)*/ }
    ],
    prizeChance: 0,
    itemNormalElement: [
      <div className={styles.item} />,
      <div className={styles.item} />,
      <div className={styles.item} />,
      <div className={styles.item} />,
      <div className={styles.item} />,
      <div className={styles.item} />,
      <div className={styles.item} />,
      <div className={styles.item} />
    ],
    itemActiveElement: [
      <div className={cx(styles.item)} />,
      <div className={cx(styles.item)} />,
      <div className={cx(styles.item)} />,
      <div className={cx(styles.item)} />,
      <div className={cx(styles.item)} />,
      <div className={cx(styles.item)} />,
      <div className={cx(styles.item)} />,
      <div className={cx(styles.item)} />
    ],
    activeBtnElement: <div className={styles.item}>开始抽奖</div>,
    /**
     * 获取抽奖结果
     * 重写此方法以发送请求，从后端获得抽奖结果并按照传入的prizeList匹配对应的奖品索引，反馈给九宫格
     * @returns {number} 抽奖结果在九宫格中的索引
     */
    async getPrizeResult(prizeList) {
      const resultId = Math.floor(Math.random() * (9 - 1 + 1)) + 1;
      const resultData = prizeList.find(item => {
        return item.id === resultId;
      });
      if (resultData) {
        return resultData;
      }
    },
    animationSpacing: [50, 60, 80, 110, 150, 200, 280],
    prizeComplete: function(resultData) {}
  };

  state = {
    activeIndex: 0,
    target: {},
    animating: false,
    islock: false,
    currentRound: 0, // 当前轮次
    totalRounds: 0 // 总轮次
  };
  timeInterval = {};
  clearSelectionTimeout = null;

  setIndex = index => {
    this.setState({ activeIndex: index });
  };

  @protect
  @lockAsync()
  async drawLottery() {
    const { getPrizeResult, prizeComplete, animationSpacing, prizeList, prizeChance, showAppointmentModal, account } = this.props;

    if (account) {
      if (prizeChance && prizeChance > 0) {
        const { animating, islock } = this.state;
        if (animating) {
          return;
        }
        if (islock) {
          return;
        }
        let statusCheckResult = null;
        try {
          statusCheckResult = await getPrizeResult(prizeList);
          if (statusCheckResult === null) {
            return;
          }
        } catch (error) {
          return;
        }

        this.setState({ islock: true });

        this.setState({
          activeIndex: 1,
          animating: true,
          currentRound: 1,
          totalRounds: animationSpacing.length
        });

        let resultData = statusCheckResult;
        let resultPromise = null;

        if (!resultData) {
          try {
            resultPromise = getPrizeResult(prizeList);
          } catch (error) {
            this.setState({
              animating: false,
              islock: false,
              activeIndex: 0
            });
            return;
          }
        }

        if (isArray(animationSpacing) && animationSpacing.length > 0) {
          for (let count = 0; count < animationSpacing.length - 1; count++) {
            this.setState({ currentRound: count + 1 });
            await this.rotateAsync(animationSpacing, count);
          }

          this.setState({ currentRound: animationSpacing.length });

          if (!resultData && resultPromise) {
            try {
              resultData = await resultPromise;
              if (resultData === null) {
                this.setState({
                  animating: false,
                  islock: false,
                  activeIndex: 0
                });
                return;
              }
            } catch (error) {
              this.setState({
                animating: false,
                islock: false,
                activeIndex: 0
              });
              return;
            }
          }

          if (resultData) {
            this.setState({ target: resultData.index >= 8 ? 8 : resultData.index });
          } else {
            this.setState({
              animating: false,
              islock: false,
              activeIndex: 0
            });
            return;
          }

          await this.rotateAsync(animationSpacing, animationSpacing.length - 1);

          this.setState({
            animating: false,
            currentRound: 0,
            totalRounds: 0,
            activeIndex: resultData.index >= 8 ? 8 : resultData.index
          });

          prizeComplete(resultData);

          this.clearSelectionTimeout = setTimeout(() => {
            this.setState({ activeIndex: 0 });
          }, 500);

          this.setState({ islock: false });
        }
      } else {
        AntdMessage.info('完成任务可获取抽奖次数');
        return;
      }
    } else {
      showAppointmentModal && showAppointmentModal();
    }
  }

  /**
   * 贝塞尔曲线丝滑旋转动画：从快到慢，无停顿
   * @param animationSpacing {array} - 动画间隔数组
   * @param count {number} - 当前轮次
   * @returns {Promise<any>}
   */
  rotateAsync = (animationSpacing, count) => {
    return new Promise((resolve, reject) => {
      try {
        let stepCount = 0;
        const isLastRound = count === animationSpacing.length - 1;
        const interval = animationSpacing[count];
        const rotationSequence = [1, 2, 3, 5, 8, 7, 6, 4];

        const oneRound = setInterval(() => {
          const { activeIndex, target } = this.state;

          if (!isLastRound) {
            if (stepCount < 8) {
              const currentSequenceIndex = rotationSequence.indexOf(activeIndex);
              const nextSequenceIndex = (currentSequenceIndex + 1) % rotationSequence.length;
              const nextIndex = rotationSequence[nextSequenceIndex];
              this.setState({ activeIndex: nextIndex });
              stepCount++;
            } else {
              clearInterval(oneRound);
              resolve();
            }
          } else {
            if (activeIndex !== target) {
              const currentSequenceIndex = rotationSequence.indexOf(activeIndex);
              const nextSequenceIndex = (currentSequenceIndex + 1) % rotationSequence.length;
              const nextIndex = rotationSequence[nextSequenceIndex];
              this.setState({ activeIndex: nextIndex });
            } else {
              clearInterval(oneRound);
              resolve();
            }
          }
        }, interval);

        this.timeInterval = oneRound;
      } catch (e) {
        reject(e);
      }
    });
  };

  /**
   *
   * @param index{number} - 九宫格的索引值，顺时针对应奖品格的位置,顺时针对应,顺时针对应
   * @returns {*}
   */
  renderSquareItem(index) {
    const { activeIndex } = this.state;
    const { itemNormalElement, itemActiveElement, activeBtnElement } = this.props;
    if (index !== 0) {
      return index === activeIndex ? itemActiveElement[index - 1] : itemNormalElement[index - 1];
    } else {
      return (
        <div
          className={styles.btnDraw}
          onClick={() => {
            this.drawLottery();
          }}
        >
          {activeBtnElement}
        </div>
      );
    }
  }

  renderNineSquare() {
    return (
      <div className={styles.root}>
        <div className={styles.line}>
          {this.renderSquareItem(1)}
          {this.renderSquareItem(2)}
          {this.renderSquareItem(3)}
        </div>
        <div className={styles.line}>
          {this.renderSquareItem(4)}
          {this.renderSquareItem(5)}
        </div>
        <div className={styles.line}>
          {this.renderSquareItem(6)}
          {this.renderSquareItem(7)}
          {this.renderSquareItem(8)}
        </div>
      </div>
    );
  }

  componentWillUnmount() {
    clearInterval(this.timeInterval);
    if (this.clearSelectionTimeout) {
      clearTimeout(this.clearSelectionTimeout);
    }
  }

  render() {
    const { className, activeBtnElement } = this.props;
    const { activeIndex, animating, currentRound, totalRounds, target } = this.state;
    return (
      <div className={cx(styles.root, className)}>
        {this.renderNineSquare()}
        <div
          className={styles.btnDraw}
          onClick={() => {
            this.drawLottery();
          }}
        >
          {activeBtnElement}
        </div>
      </div>
    );
  }
}
